import {
    getData,
    getElement,
    resetForm,
    setSelect2Ajax,
} from "../../../../../helpers";

export const storeModule = () => {
    let FormMoule = document.querySelector("#formModule");

    FormMoule.elements.save.addEventListener("click", () => {
        if (FormMoule.reportValidity()) {
            FormMoule.submit();
        }
    });
};

export const create = (url, title) => {
    let FormMoule = document.querySelector("#formModule");
    resetForm(FormMoule, title, url);
    // Estos foreach podrían ser cuestionables
    FormMoule.querySelectorAll("select[is^=select-]")?.forEach((item) => {
        if (getData(item, "data-default-value")) {
            setSelect2Ajax(
                item,
                getData(item, "data-default-value"),
                getData(item, "data-default-text")
            );
        }
    });
};

export const edit = (url, title, data) => {
    data = JSON.parse(atob(data));
    let FormMoule = document.querySelector("#formModule");
    resetForm(FormMoule, title, url);
    FormMoule.elements.name.value = data.name;
    FormMoule.elements.description.value = data.description;
};
